import Agreements from './Agreements';

export default Agreements;
